// extracted by mini-css-extract-plugin
export default {"container":"index_container__vIqEB","headerWrap":"index_headerWrap__gt6DH","resourceContainer":"index_resourceContainer__7iyoo","cardContainer":"index_cardContainer__2S9xx"};